import { ReactElement } from 'react';

import { Location, ReservationPreference } from '@dreryk/egabinet-waitlist-frontend-api';
import { HealthcareProviderLocationIdentifier } from '@dreryk/egabinet-appointment-frontend-api';

import { StyledFlex, TextView } from '@dreryk/react-components';
import { createSingleInterpolatedTranslationKey, Translate } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';
import { IncompatiblePreferenceNotification } from '../IncompatiblePreferenceNotification';
import { HealthcareProviderLocationPart } from '../../WaitlistEntryConfirmReservationHealthcareLocation.loader';

import { isLocationIncompatible } from './LocationTextView.utils';

type LocationTextViewProps = {
   appointmentLocationIdentifier: HealthcareProviderLocationIdentifier | undefined;
   appointmentLocationPart: HealthcareProviderLocationPart | undefined;
   location: Location | undefined;
   reservationPreference: ReservationPreference;
};

export const LocationTextView = (props: LocationTextViewProps): ReactElement => {
   const priority = props.reservationPreference === 'LOCATION';
   const shouldShowNotification = isLocationIncompatible(props.appointmentLocationIdentifier, props.location);

   return (
      <TextView testId={'healthcareProviderLocation'} label={translationKeys.healthcareProviderLocation}>
         <StyledFlex direction={'column'} gap={'8px'}>
            {props.appointmentLocationPart ? (
               props.appointmentLocationPart.name
            ) : (
               <Translate>{translationKeys.anyLocation}</Translate>
            )}
            {shouldShowNotification && props.location ? (
               <IncompatiblePreferenceNotification
                  testId={'locationPreference'}
                  warning={priority}
                  label={createSingleInterpolatedTranslationKey(
                     priority ? translationKeys.priorityPreference : translationKeys.preference,
                     'label',
                     props.location.name
                  )}
               />
            ) : null}
         </StyledFlex>
      </TextView>
   );
};
